/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Workflow = {
    HighIntent: 'HIGH_INTENT',
    LowIntent: 'LOW_INTENT'
} as const;
export type Workflow = typeof Workflow[keyof typeof Workflow];


export function instanceOfWorkflow(value: any): boolean {
    for (const key in Workflow) {
        if (Object.prototype.hasOwnProperty.call(Workflow, key)) {
            // @ts-ignore
            if (Workflow[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkflowFromJSON(json: any): Workflow {
    return WorkflowFromJSONTyped(json, false);
}

export function WorkflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workflow {
    return json as Workflow;
}

export function WorkflowToJSON(value?: Workflow | null): any {
    return value as any;
}

